import {
    messageGroupLabel,
    meetingRequestGroupLabel,
    meetingCancelationGroupLabel,
    meetingDeclineGroupLabel,
    meetingAcceptanceGroupLabel,
    meetingTentativeAcceptanceGroupLabel,
    automaticReplyGroupLabel,
    undeliveredReportGroupLabel,
    otherGroupLabel,
} from './getGroupHeaderForItemClass.locstring.json';
import loc from 'owa-localize';
import type GroupHeader from '../type/GroupHeader';
import type { TableView } from 'owa-mail-list-store';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';

/**
 * Get GroupHeader for row based on ItemClass
 * @param rowKey item key for which we want to lookup ItemClass group range
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForItemClass(
    rowKey: string,
    tableView: TableView
): GroupHeader {
    const item = MailRowDataPropertyGetter.getItem(rowKey, tableView);
    const itemClass = item?.ItemClass;

    if (itemClass?.indexOf('IPM.Schedule.Meeting.Canceled') !== -1) {
        return {
            headerText: () => loc(meetingCancelationGroupLabel),
            headerId: 'MeetingCancelation',
        };
    } else if (itemClass?.indexOf('IPM.Schedule.Meeting.Request') !== -1) {
        return {
            headerText: () => loc(meetingRequestGroupLabel),
            headerId: 'MeetingRequest',
        };
    } else if (itemClass?.indexOf('IPM.Schedule.Meeting.Resp.Neg') !== -1) {
        return {
            headerText: () => loc(meetingDeclineGroupLabel),
            headerId: 'MeetingDecline',
        };
    } else if (itemClass?.indexOf('IPM.Schedule.Meeting.Resp.Pos') !== -1) {
        return {
            headerText: () => loc(meetingAcceptanceGroupLabel),
            headerId: 'MeetingAcceptance',
        };
    } else if (itemClass?.indexOf('IPM.Schedule.Meeting.Resp.Tent') !== -1) {
        return {
            headerText: () => loc(meetingTentativeAcceptanceGroupLabel),
            headerId: 'MeetingTentativeAcceptance',
        };
    } else if (itemClass?.indexOf('IPM.Schedule.Meeting') !== -1) {
        return {
            headerText: () => loc(meetingRequestGroupLabel),
            headerId: 'MeetingRequest',
        };
    } else if (
        itemClass?.indexOf('IPM.Note.Rules.OofTemplate.Microsoft') !== -1 ||
        itemClass?.indexOf('IPM.Note.Rules.ReplyTemplate.Microsoft') !== -1
    ) {
        return {
            headerText: () => loc(automaticReplyGroupLabel),
            headerId: 'AutomaticReply',
        };
    } else if (
        itemClass?.indexOf('IPM.Note.NonDeliveryReceipt') !== -1 ||
        itemClass?.indexOf('IPM.Note.DeliveryReceipt') !== -1 ||
        itemClass?.indexOf('REPORT.IPM.Note.NDR') !== -1
    ) {
        return {
            headerText: () => loc(undeliveredReportGroupLabel),
            headerId: 'UndeliveredReport',
        };
    } else if (itemClass?.indexOf('IPM.Note') !== -1) {
        return {
            headerText: () => loc(messageGroupLabel),
            headerId: 'Message',
        };
    } else {
        return {
            headerText: () => loc(otherGroupLabel),
            headerId: 'Other',
        };
    }
}
